import { render, staticRenderFns } from "./MenuItemStatus.vue?vue&type=template&id=552256e6&"
import script from "./MenuItemStatus.vue?vue&type=script&lang=js&"
export * from "./MenuItemStatus.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports